var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerfume(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 219.88,
    y: 49.844,
    style: {
      fill: "#DFDFE0"
    },
    width: 99.473,
    height: 33.391
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CECED1"
    },
    points: "188.807,163.76 141.447,163.76 141.447,17.417 188.807,17.417 236.167,17.417  236.167,163.76 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BEBEC1"
    },
    points: "212.487,163.76 188.807,163.76 188.807,17.417 212.487,17.417 236.167,17.417  236.167,163.76 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D0F0EA"
    },
    d: "M293.832,512H83.784l-15.821-21.098c-59.385-79.191-55.245-189.138,9.929-263.638l25.496-29.145 c0,0,19.782-24.621,85.419-24.621s85.419,24.621,85.419,24.621l25.496,29.145c65.173,74.499,69.315,184.447,9.929,263.638 L293.832,512z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E0D3"
    },
    d: "M299.723,227.266l-25.496-29.145c0,0-19.782-24.621-85.419-24.621V512h105.023l15.821-21.098 C369.038,411.713,364.896,301.765,299.723,227.266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#92E0D3"
    },
    d: "M26.316,355.272c-2.247,47.363,11.519,95.455,41.647,135.63L83.784,512h210.048l15.821-21.098 c30.128-40.175,43.894-88.267,41.647-135.63H26.316z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6DB2A6"
    },
    d: "M188.807,355.272V512h105.023l15.821-21.098c30.128-40.175,43.894-88.267,41.647-135.63H188.807z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.108,
    y: 178.822,
    style: {
      fill: "#EDEDEE"
    },
    width: 33.391,
    height: 246.317
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.804,
    y: 178.822,
    style: {
      fill: "#DFDFE0"
    },
    width: 16.696,
    height: 246.317
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9B9BA1"
    },
    points: "188.807,115.664 103.388,115.664 103.388,198.121 188.807,198.121 274.227,198.121  274.227,115.664 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#757576"
    },
    points: "231.517,115.664 188.807,115.664 188.807,198.121 231.517,198.121 274.227,198.121  274.227,115.664 "
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#DC90CC"
    },
    cx: 391.111,
    cy: 66.54,
    rx: 94.82,
    ry: 66.54
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C0369E"
    },
    d: "M485.928,66.54c0,36.749-42.45,66.54-94.815,66.54s-94.815-29.792-94.815-66.54 C319.355,66.54,444.988,66.54,485.928,66.54z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerfume);
export default __webpack_public_path__ + "static/media/perfume.437dafcb6c56f8543a3b270865d4eac8.svg";
export { ForwardRef as ReactComponent };